// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "PeergroupForm__textCenter__kaxa5";
export const peergroupForm = "PeergroupForm__peergroupForm__hZLxw";
export const groupSizePlace = "PeergroupForm__groupSizePlace__tQdNZ";
export const groupSizeWrapper = "PeergroupForm__groupSizeWrapper__PwzOP";
export const groupTooSmall = "PeergroupForm__groupTooSmall__8pJlZ";
export const groupSearching = "PeergroupForm__groupSearching__y7rzr";
export const groupSize = "PeergroupForm__groupSize__WbApE";
export const tooltipContainer = "PeergroupForm__tooltipContainer__FeiBn";
export const fieldRow = "PeergroupForm__fieldRow__8h4Sb";
export const fieldWrapper = "PeergroupForm__fieldWrapper__QPJfA";
export const addFilterButtonWrapper = "PeergroupForm__addFilterButtonWrapper__xOFOy";
export const addFilterButton = "PeergroupForm__addFilterButton__QB-sT";
export const cancelButtonWrapper = "PeergroupForm__cancelButtonWrapper__-haeG";
export const addFilterIcon = "PeergroupForm__addFilterIcon__88WMF";
export const deleteFilterIcon = "PeergroupForm__deleteFilterIcon__l9heo";
export const fieldIcon = "PeergroupForm__fieldIcon__up2xW";
export const filtersPopup = "PeergroupForm__filtersPopup__wNfvp font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const filterOption = "PeergroupForm__filterOption__b837e";
export const popupHeader = "PeergroupForm__popupHeader__Y-rz4 font-faces__sansBold__vF+EN font-faces__sans__uCf65";